import {useDevelopmentLiveUpdates} from '../../../hooks/use-development-live-updates'
import {useLayoutQuery} from '../../../page-data/loaders/use-layout-query'
import {useDevelopmentQuery} from './route-queries'

export function useDevelopment() {
  const {data: layoutData} = useLayoutQuery()
  useDevelopmentLiveUpdates(layoutData?.aliveChannels)

  return useDevelopmentQuery()
}
